import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import DataManager from '../UsageDashboard/DataManager';
import CompanyUsageCard from '../../organisms/CompanyUsageCard';
import './customerSuccess.css';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import Styled from '../PayCompany/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import api from '../../lib/api';
// eslint-disable-next-line react/no-deprecated
class CustomerSuccess extends React.Component {
  constructor(props, context) {
    super(props, context);
    // eslint-disable-next-line react/prop-types
    DataManager.setCompanyId(this.props.match.params.companyId);
    this.state = {
      visitorsPopoverOpen: false,
      inquiriesPopoverOpen: false,
      visitorsByCity: [],
      visitorsByCountry: [],
      inquiriesByCity: [],
      inquiriesByCountry: [],
      showByCity: true,
      showByCountry: false,
      companyId: this.props.match.params.companyId,
      companySignature: [],
      showInquiryByCity: true,
      showInquiryByCountry: false,
      feedback: '',
      notes: '',
      showSnackBar: false,
      showFeedbackLoader: false,
      showNotesLoader: false,
      disableFeedbackSubmitButton: false,
      disableNotesSubmitButton: false,
      payments: null
    };
  }

  componentDidMount() {
    api
      .getLastPayment({ companyId: this.props.match.params.companyId })
      .then(value => {
        this.setState({
          payments: [value]
        });
      })
      .catch(reason => console.log(reason));
  }

  calcPercentageBetweenDates = (startDate, endDate) => {
    const momentStart = moment(startDate, 'Do MMMM YYYY, hh:mm a');
    const momentEnd = moment(endDate, 'Do MMMM YYYY, hh:mm a');
    const today = moment();
    if (momentEnd < today) {
      return '100%';
    } else {
      const usedDays = today.diff(momentStart, 'days');
      const totalDays = momentEnd.diff(momentStart, 'days');
      return Math.round((usedDays / totalDays) * 100) + '%';
    }
  };

  onFeedbackChange = e => {
    this.setState({
      feedback: e.target.value
    });
  };

  onNotesChange = e => {
    this.setState({
      notes: e.target.value
    });
  };

  onFeedbackSubmit = async () => {
    const { feedback, companyId, disableFeedbackSubmitButton } = this.state;
    if (feedback) {
      this.setState({
        disableFeedbackSubmitButton: true
      });
      await api.saveCompanyFeedback({
        companyId: companyId,
        type: 'ON_CALL',
        feedback: feedback
      });
      this.setState({
        feedback: '',
        disableFeedbackSubmitButton: false,
        showSnackBar: true,
        message: 'Feedback saved'
      });
    } else {
      this.setState({
        message: 'Feedback cannot be blank',
        showSnackBar: true,
        showFeedbackLoader: false,
        disableFeedbackSubmitButton: false
      });
    }
  };

  onNotesSubmit = async () => {
    const { companyId, notes } = this.state;
    if (notes) {
      this.setState({
        disableNotesSubmitButton: true
      });
      await api.saveCompanyFeedback({
        companyId: companyId,
        type: 'NOTES',
        feedback: notes
      });
      this.setState({
        notes: '',
        disableNotesSubmitButton: false,
        showSnackBar: true,
        message: 'Notes saved'
      });
    } else {
      this.setState({
        message: 'Notes cannot be blank',
        showSnackBar: true,
        disableNotesSubmitButton: false
      });
    }
  };

  renderSnackbarMessage = () => {
    const { message } = this.state;
    setTimeout(() => {
      this.setState({
        message: '',
        showSnackBar: false
      });
    }, 6000);
    return <Styled.SnackbarMessage>{message}</Styled.SnackbarMessage>;
  };

  renderCompanyCard = () => {
    const { companyId } = this.state;
    return <CompanyUsageCard companyId={companyId} />;
  };

  renderLastPayment = () => {
    const { payments } = this.state;
    return (
      payments && (
        <div className={'LastPayment'}>
          <table>
            <thead>
              <tr>
                <td>Plan Type</td>
                <td>Duration</td>
                <td>Amount</td>
                <td>Type</td>
                <td>Start Date</td>
                <td>End Date</td>
                <td>Consumed</td>
              </tr>
            </thead>
            <tbody>
              {payments.map((row, i) => {
                return (
                  <tr>
                    <td>{row.planType}</td>
                    <td>{`${row.duration} months`}</td>
                    <td> {`$${row.amount}`}</td>
                    <td>{row.productType}</td>
                    <td>{row.planStartDate}</td>
                    <td>{row.planEndDate}</td>
                    <td>
                      {this.calcPercentageBetweenDates(
                        row.planStartDate,
                        row.planEndDate
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )
    );
  };

  renderNotes = () => {
    return <div />;
  };

  renderFeedback = () => {
    const {
      disableFeedbackSubmitButton,
      disableNotesSubmitButton,
      feedback,
      notes
    } = this.state;
    return (
      <div className={'FeedbackNotesContainer'}>
        <div className={'Feedback'}>
          <label>Feedback</label>
          <textarea
            className={'FeedbackInput'}
            onChange={this.onFeedbackChange}
            value={feedback}
          ></textarea>

          <div>
            <Button
              fullWidth
              variant="raised"
              color="primary"
              disabled={disableFeedbackSubmitButton}
              className={'SubmitButton'}
              onClick={this.onFeedbackSubmit}
            >
              Submit
            </Button>
          </div>
        </div>

        <div className={'Notes'}>
          <label>Notes</label>
          <textarea
            className={'FeedbackInput'}
            onChange={this.onNotesChange}
            value={notes}
          ></textarea>
          <div>
            <Button
              fullWidth
              variant="raised"
              color="primary"
              disabled={disableNotesSubmitButton}
              className={'SubmitButton'}
              onClick={this.onNotesSubmit}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { roles } = this.props;
    const { companyId, showSnackBar } = this.state;

    return (
      <div className="App">
        <div
          style={{
            marginTop: 75
          }}
        />

        {roles && roles.indexOf('customer_success') !== -1 ? (
          companyId ? (
            <div>
              {this.renderCompanyCard()}
              {this.renderLastPayment()}
              {this.renderNotes()}
              {this.renderFeedback()}
            </div>
          ) : null
        ) : (
          <div
            style={{
              textAlign: 'center',
              fontSize: '50px',
              color: 'red',
              marginTop: 133
            }}
          >
            You dont have access to this page
          </div>
        )}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          open={!!showSnackBar}
          autoHideDuration={6000}
          message={this.renderSnackbarMessage()}
          action={[
            <IconButton key={0} onClick={this.onSnackbarClose}>
              <CloseIcon nativeColor="#fff" />
            </IconButton>
          ]}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  roles: state.auth.roles
});

export default connect(mapStateToProps)(CustomerSuccess);



// WEBPACK FOOTER //
// ./src/pages/CustomerSuccess/index.js